"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');





var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/composite/composite-hover.tsx
var _dom = require('@ariakit/core/utils/dom');
var _focus = require('@ariakit/core/utils/focus');




var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "div";
function getMouseDestination(event) {
  const relatedTarget = event.relatedTarget;
  if ((relatedTarget == null ? void 0 : relatedTarget.nodeType) === Node.ELEMENT_NODE) {
    return relatedTarget;
  }
  return null;
}
function hoveringInside(event) {
  const nextElement = getMouseDestination(event);
  if (!nextElement) return false;
  return _dom.contains.call(void 0, event.currentTarget, nextElement);
}
var symbol = /* @__PURE__ */ Symbol("composite-hover");
function movingToAnotherItem(event) {
  let dest = getMouseDestination(event);
  if (!dest) return false;
  do {
    if (_misc.hasOwnProperty.call(void 0, dest, symbol) && dest[symbol]) return true;
    dest = dest.parentElement;
  } while (dest);
  return false;
}
var useCompositeHover = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useCompositeHover2({
    store,
    focusOnHover = true,
    blurOnHoverEnd = !!focusOnHover,
    ...props
  }) {
    const context = _UCZW3OGHcjs.useCompositeContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const isMouseMoving = _3BSDKDKDcjs.useIsMouseMoving.call(void 0, );
    const onMouseMoveProp = props.onMouseMove;
    const focusOnHoverProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, focusOnHover);
    const onMouseMove = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onMouseMoveProp == null ? void 0 : onMouseMoveProp(event);
      if (event.defaultPrevented) return;
      if (!isMouseMoving()) return;
      if (!focusOnHoverProp(event)) return;
      if (!_focus.hasFocusWithin.call(void 0, event.currentTarget)) {
        const baseElement = store == null ? void 0 : store.getState().baseElement;
        if (baseElement && !_focus.hasFocus.call(void 0, baseElement)) {
          baseElement.focus();
        }
      }
      store == null ? void 0 : store.setActiveId(event.currentTarget.id);
    });
    const onMouseLeaveProp = props.onMouseLeave;
    const blurOnHoverEndProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, blurOnHoverEnd);
    const onMouseLeave = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      var _a;
      onMouseLeaveProp == null ? void 0 : onMouseLeaveProp(event);
      if (event.defaultPrevented) return;
      if (!isMouseMoving()) return;
      if (hoveringInside(event)) return;
      if (movingToAnotherItem(event)) return;
      if (!focusOnHoverProp(event)) return;
      if (!blurOnHoverEndProp(event)) return;
      store == null ? void 0 : store.setActiveId(null);
      (_a = store == null ? void 0 : store.getState().baseElement) == null ? void 0 : _a.focus();
    });
    const ref = _react.useCallback.call(void 0, (element) => {
      if (!element) return;
      element[symbol] = true;
    }, []);
    props = {
      ...props,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref),
      onMouseMove,
      onMouseLeave
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var CompositeHover = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function CompositeHover2(props) {
    const htmlProps = useCompositeHover(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);




exports.useCompositeHover = useCompositeHover; exports.CompositeHover = CompositeHover;
